import http from 'http';
import crossFetch from 'cross-fetch';

const agent =
  http.Agent &&
  new http.Agent({
    keepAlive: true,
    keepAliveMsecs: 1500,
  });

export const fetch = (url, options) =>
  crossFetch
    .fetch(url, { agent, timeout: 3500, ...options })
    .then(response => {
      if (typeof window === 'undefined') {
        console.info(`${response.status} -  ${url}`);
      }
      return response;
    })
    .catch(e => {
      console.error(JSON.stringify({ error: e }));
      throw e;
    });

export const fetchJSON = (url, options) =>
  fetch(url, options)
    .then(response => Promise.all([response, response.json()]))
    .then(([response, body]) => {
      if (response.status >= 400) {
        const error = new Error(`fetchJSON: ${response.statusText} - ${response.url}`);
        error.status = response.status;
        error.url = response.url;
        error.body = body;
        throw error;
      }

      return body;
    });

export const postJSON = (url, body, headers) =>
  fetch(url, {
    method: 'POST',
    body,
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
  });
